import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-mj-reddark text-mj-bg relative overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-10">
      <div className="grid md:grid-cols-3 gap-12 mb-20">
        <div>
          <img src="/logo.png" alt="Manjaadii" className="h-16 w-auto object-contain mb-5 opacity-95" />
          <p className="overline text-mj-gold mb-5">Manjaadii Ethnics OPC Pvt. Ltd.</p>
          <p className="font-sans-mj text-sm leading-relaxed text-mj-bg/80">
            VTC Rampura, PO Bidrahalli,<br/>Bangalore South, Bangalore,<br/>Karnataka — 560049
          </p>
        </div>
        <div>
          <p className="overline text-mj-gold mb-5">Reach Us</p>
          <a href="mailto:Contact@manjaadii.com" className="flex items-center gap-2 text-sm mb-3 text-mj-bg/80 hover:text-mj-gold transition-colors"><Mail className="w-4 h-4"/> Contact@manjaadii.com</a>
          <a href="tel:9739209737" className="flex items-center gap-2 text-sm mb-3 text-mj-bg/80 hover:text-mj-gold transition-colors"><Phone className="w-4 h-4"/> +91 97392 09737</a>
          <a href="#" className="flex items-center gap-2 text-sm text-mj-bg/80 hover:text-mj-gold transition-colors"><Instagram className="w-4 h-4"/> @manjaadii</a>
        </div>
        <div>
          <p className="overline text-mj-gold mb-5">Explore</p>
          <div className="flex flex-col gap-3">
            <Link to="/story" className="text-sm text-mj-bg/80 hover:text-mj-gold transition-colors w-fit">Our Story</Link>
            <Link to="/collection" className="text-sm text-mj-bg/80 hover:text-mj-gold transition-colors w-fit">Collection</Link>
            <Link to="/contact" className="text-sm text-mj-bg/80 hover:text-mj-gold transition-colors w-fit">Contact</Link>
          </div>
        </div>
      </div>

      <div className="kasavu-border mb-10 opacity-40" />
      <h2 className="font-serif-mj text-[15vw] md:text-[11vw] leading-[0.85] tracking-tight text-mj-bg/95 select-none">wear your<br/><span className="italic text-mj-gold">heritage</span></h2>
      <p className="mt-12 text-xs text-mj-bg/50 tracking-wide">© {new Date().getFullYear()} Manjaadii · Rooted in Kerala, crafted in Bangalore.</p>
    </div>
  </footer>
);
